// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aZunC8hy_8AMJRj97X77{background-color:var(--interaction-brand-active);height:1.5px;position:absolute;top:0;right:0;transform:translateY(-50%)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aZunC8hy_8AMJRj97X77`
};
export default ___CSS_LOADER_EXPORT___;
